"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgExclamationCircleSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M12 13V6"
  }), React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12-6.628 0-12-5.372-12-12S5.372 0 12 0zm0 16.085a1.02 1.02 0 100 2.043 1.02 1.02 0 100-2.043zm0-10.979a.766.766 0 00-.759.662l-.007.104v7.15l.007.103a.766.766 0 001.518 0l.007-.104V5.872l-.007-.104A.766.766 0 0012 5.106z",
    fill: "inherit"
  })));
}

var _default = SvgExclamationCircleSolid;
exports.default = _default;